export default __webpack_public_path__ + "static/media/BB_IND_01.6d6ac92d.jpg";